// src/Pages/Usuario/Agenda/components/HorariosGrid.jsx
import React from "react";
import SlotBtn from "./SlotBtn";

export default function HorariosGrid({
  activeDate,
  horarios,
  estadoPorHora,
  ocupacionBloques,
  effectiveBreaks,
  primarySlot,
  onPickPrimary,
  esEntrenamiento,
  esKine1Sesion,
  modalidadKine,
  reglaServicio,
  categoria,
  duracionSesion,
}) {
  if (!activeDate) return null;

  if (!horarios || horarios.length === 0) {
    return (
      <p className="text-gray-600 text-sm mt-3">
        No hay horarios disponibles para esta fecha.
      </p>
    );
  }

  return (
    <div className="mt-5">
      <label className="block mb-2 font-semibold text-[#0E1A36]">
        Horarios disponibles
      </label>

      {/* GRID DE HORAS */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {horarios.map((h) => {
          // Info para el slot (ocupación del bloque)
          const info = ocupacionBloques?.get(h) || {
            total: 0,
            topables: 0,
            exclusiva: false,
            bufferPrevio: false,
            postBuffer: false,
          };

          // Detectar break
          const isBreak = effectiveBreaks?.some(
            (b) => h >= b.start && h < b.end
          );

          return (
            <SlotBtn
              key={`${activeDate}_${h}`}
              ymd={activeDate}
              hhmm={h}
              primarySlot={primarySlot}
              onPickPrimary={onPickPrimary}

              // ⭐ Info del slot
              info={info}

              // ⭐ Break directo
              isBreak={isBreak}

              // ⭐ Lógicas kine / entrenamiento
              esKine1Sesion={esKine1Sesion}
              modalidadKine={modalidadKine}
              esEntrenamiento={esEntrenamiento}

              // ⭐ NUEVO: reglas dinámicas (duración, buffers)
              reglaServicio={reglaServicio}

              // ⭐ NUEVO: mapa completo de ocupación (para revisar bloques siguientes)
              ocupacionBloques={ocupacionBloques}

              // ⭐ NUEVO: break completo
              effectiveBreaks={effectiveBreaks}
              categoria={categoria}
            />
          );
        })}
      </div>

      {/* MENSAJE ACLARATORIO DE DURACIÓN */}
      <div className="mt-4 rounded-lg bg-blue-50 border border-blue-200 px-4 py-3 text-sm text-blue-900">
        <span className="font-semibold">⏱ Duración de la sesión:</span>{" "}
        {duracionSesion} minutos.
        <br />
        <span className="text-blue-700">
          Si comienzas a una hora, tu sesión finaliza{" "}
          <strong>{duracionSesion} minutos después</strong>.
        </span>
      </div>

      {/* LEYENDAS */}
      <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-gray-600">
        <div className="inline-flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded bg-[#00698f]"></span>
          Seleccionado
        </div>

        <div className="inline-flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded bg-yellow-300 border border-yellow-400"></span>
          1/2 cupo disponible
        </div>

        <div className="inline-flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded bg-rose-100 border border-rose-200"></span>
          Reservado
        </div>

        <div className="inline-flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded bg-gray-300"></span>
          No disponible
        </div>
      </div>
    </div>
  );
}
